import * as Yup from "yup";

const firstSchema = Yup.object().shape({
  descricao: Yup.string().required("*A descrição é obrigatória"),
});

export default firstSchema;
